import React from "react";
import {useStyles} from "../styles/styles";
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Replay from "@mui/icons-material/Replay";
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {getDecimal} from "../global/utils";

const FeeList = (props) => {
    const fees = props.fees;
    const openFees = props.openFees;
    const setOpenFees = props.setOpenFees;
    const classes = useStyles;
    const cellSx = {...classes.tableCell, fontSize: '.9rem', padding: '.3rem'};

    // MUI v9 removed disableEscapeKeyDown, so the reason is filtered in onClose
    // instead to keep Escape from closing this dialog.
    return (
        <Dialog
            fullWidth
            maxWidth='md'
            open={openFees}
            onClose={(event, reason) => { if (reason !== 'escapeKeyDown') setOpenFees(false); }}
            sx={classes.dialog}
            slotProps={{
                paper: {
                    'aria-label': 'Non-Case Fees'
                }
            }}
        >
            <DialogTitle>
                {/* DialogTitle already renders an h2, so a heading here nested one
                    inside the other. A block span keeps the appearance identical
                    and leaves the DialogTitle as the single heading. */}
                <Typography variant="h6" component='span' sx={{...classes.title, display: 'block'}}>Non-Case Fees</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Paper elevation={3} sx={{...classes.tableContainer, padding: '1rem', overflow: 'auto'}}>
                    <TableContainer sx={{...classes.list, maxHeight: '100%'}}>
                        <Table size="small" aria-label="Available non-case fees">
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th" scope="col" sx={{...cellSx, width: '25%'}}>Fee Name</TableCell>
                                    <TableCell component="th" scope="col" align="right" sx={{...cellSx, width: '17%'}}>Amount</TableCell>
                                    <TableCell component="th" scope="col" align="right" sx={{...cellSx, width: '17%'}}>Allow Amt. Entry</TableCell>
                                    <TableCell component="th" scope="col" align="center" sx={cellSx}>Entry Instructions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { fees && fees.map((fee) => (
                                    <TableRow key={fee.name}>
                                        <TableCell component="th" scope="row" sx={cellSx}>{fee.name}</TableCell>
                                        <TableCell align="right" sx={cellSx}>{getDecimal(fee.amount)}</TableCell>
                                        <TableCell align="right" sx={cellSx}>{fee.allowAmountEntry ? 'Yes' : 'No'}</TableCell>
                                        <TableCell sx={cellSx}>{fee.payorInstructions}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined"
                        color="primary"
                        startIcon={<Replay/>}
                        sx={classes.button}
                        onClick={() => setOpenFees(false)}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default FeeList;